import { createIcon } from '@chakra-ui/icons';

export const UserEdit = createIcon({
  displayName: 'UserEdit',
  viewBox: '0 0 18 18',
  path: [
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_606_3035)">
        <path
          d="M12 16L9.5 16.5L10 14L14.5 9.5L16.5 11.5L12 16Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 8C9.79493 8 11.25 6.54493 11.25 4.75C11.25 2.95507 9.79493 1.5 8 1.5C6.20507 1.5 4.75 2.95507 4.75 4.75C4.75 6.54493 6.20507 8 8 8Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.9999 10.577C8.6739 10.527 8.3399 10.5 7.9999 10.5C4.5789 10.5 1.7809 13.145 1.5249 16.5H6.4999"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_606_3035">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
